<template>
  <div class="MdIco fl0" :class="icnClass">
    <div>
      <span :style="icnStyle"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'lineFlexIcnElement',
  props: {
    data: {
      type: Object,
    },
  },
  computed: {
    icnClass() {
      const cl = {
        ExXXs: this.data.size === 'xxs',
        ExXs: this.data.size === 'xs',
        ExSm: this.data.size === 'sm',
        ExMd: this.data.size === 'md',
        ExLg: this.data.size === 'lg',
        ExXl: this.data.size === 'xl',
        ExXXl: this.data.size === 'xxl',
        Ex3Xl: this.data.size === '3xl',
        Ex4Xl: this.data.size === '4xl',
        Ex5Xl: this.data.size === '5xl',
        ExMgnTXs: this.data.margin === 'xs',
        ExMgnTSm: this.data.margin === 'sm',
        ExMgnTMd: this.data.margin === 'md',
        ExMgnTLg: this.data.margin === 'lg',
        ExMgnTXl: this.data.margin === 'xl',
        ExMgnTXXl: this.data.margin === 'xxl',
      };
        // Todo add margin handle
      return cl;
    },
    icnStyle() {
      const style = {
        width: '1em',
      };
      if (this.data) {
        if (this.data.url) {
          style.backgroundImage = `url('${this.data.url}')`;
        }
        if (this.data.aspectRatio) {
          const s = this.data.aspectRatio.split(':');
          const result = ((+s[0]) / (+s[1])).toFixed(2);
          style.width = `${result}em`;
        }
        if (this.data.offsetTop) style.top = this.data.offsetTop;
        if (this.data.offsetBottom) style.bottom = this.data.offsetBottom;
        if (this.data.offsetStart) style.left = this.data.offsetStart;
        if (this.data.offsetEnd) style.right = this.data.offsetEnd;
      }
      return style;
    },
  },
};
</script>
